import * as PIXI from 'pixi.js';
import BaseSlotReelsContainer from "Engine/slots/reels/BaseSlotReelsContainer";
import SoundManager from "Engine/soundManager/SoundManager";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import EntryPoint from "Engine/EntryPoint";
import NearWinCalculator from "../NearWinCalculator";

export default class ReelsContainer extends BaseSlotReelsContainer {
    constructor(data, displayItemData) {
        super(data, displayItemData);

        //this.buildMask();
        //this.changeState(2);
    }

    buildMask(value) {
        let width = value === 1 ? ((328 + 10) * 5) : ((252 + 8) * 5);
        let height = value === 1 ? (328 * 3 - 3) : (252 * 3 - 3);

        let mask = new PIXI.Graphics();
        mask.beginFill(0x0, 1);
        mask.drawRect(-width / 2, -height / 2, width, height);
        mask.endFill();
        this.addChild(mask);
        this.mask = mask;
    }

    addListeners() {
        //super.addListeners();
        GlobalDispatcher.add('reel:stopped', this.onReelStopped, this);
        GlobalDispatcher.add('stateManager:changed', this.onStateChanged, this);
        //GlobalDispatcher.add('linesContainer:slowWinLine', this.showWinningSymbols, this);
        GlobalDispatcher.add('symbolAnimation:start', this.onSymbolAnimationStart, this);
        GlobalDispatcher.add('symbolAnimation:complete', this.onSymbolAnimationComplete, this);
        GlobalDispatcher.add('symbolAnimation:end', this.onSymbolAnimationComplete, this);
    }

    start() {
        this.reels.forEach((reel, index) => {
            setTimeout(() => {
                reel.startReel();
                this.reelsStarted++;
            }, 30 * index);
        });
        SoundManager.play('sounds/mainGame/ReelsMove', 1, true);
    }

    stop(data) {
        this.data = data;
        let delay = 0;
        let type = 'normal';
        this.reels.forEach((reel, index, arr) => {
            delay += NearWinCalculator.checkForReel(index) ? 2000 : (EntryPoint.GameSettings.quickSpin ? 0 : 100);
            setTimeout(() => {
                //reel.speedIndex = NearWinCalculator.nearReels.indexOf(index) !== -1 ? 5 : 1;
                type = NearWinCalculator.checkForReel(index) ? 'nearWin' : 'normal';
                reel.stopReel(this.data[index], type);
            }, delay);
        });

        let soundName = EntryPoint.GameSettings.quickSpin ? 'SymbolsQuickStop' : 'SymbolsStop';
        SoundManager.play('sounds/mainGame/' + soundName, 1, false);
    }

    setNerWinInactive(reelIndex) {
        this.reels.forEach((reel, rIndex) => {
            reel.symbols.forEach((symbol) => {
                symbol.setActive(rIndex === reelIndex);
            });
            reel.activeReel = rIndex === reelIndex;
        })
    }

    changeState(value) {
        this.goToFrame(value);
        this.reels = [];
        //this.buildMask(value);
        this.init();
    }

    onSymbolAnimationStart(event) {
        let position = event.params;
        this.reels[position[0]].symbols[position[1] + 1].startAnimation();
    }

    onSymbolAnimationComplete(event) {
        let position = event.params;
        this.reels[position[0]].symbols[position[1] + 1].stopAnimation();
    }

    calculateNearWin() {
        let count = 0;
        let near = false;
        let arr = [];
        this.data.forEach((reel) => {
            if (reel.indexOf(1) !== -1) {
                count++
            }
            arr.push(near);
            near = count >= 2;
        });
        return arr;
    }

    onReelStopped(event) {
        if (NearWinCalculator.checkForReel(event.params)) {
            this.setNerWinInactive(event.params);
        }
        /*let soundName = EntryPoint.GameSettings.quickSpin ? 'SymbolsQuickStop' : 'SymbolsStop';
        SoundManager.play('sounds/mainGame/' + soundName, 1, false);*/
        this.reelsStarted--;
        if (this.reelsStarted === 0) {
            //setTimeout(()=>{
            SoundManager.stop('sounds/mainGame/ReelsMove');
            GlobalDispatcher.dispatch('reelsContainer:reelsStopped');
            this.setActive(true);
            //}, 500);
        }
    }
}
